<template>
  <div>
    <vx-card title="Tambah Data" subtitle="Isi data dengan benar">
      <template slot="actions">
        <div class="vx-row">
          <div class="vx-col w-full m-0">
            <vs-button icon-pack="feather" class="mt-2" @click="saveBankCashflow()"
              >Simpan Data</vs-button
            >
            <vs-button
              @click="$router.push({ name: 'bank-account-cashflow', params: { id: $route.params.id } })"
              class="ml-4 mt-2"
              type="border"
              color="danger"
              >Batal</vs-button
            >
          </div>
        </div>
      </template>
      <div slot="no-body" class="p-6">
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                  <label class="text-sm opacity-75">Jenis Bank</label>
                  <ul class="centerx vx-row">
                    <li class="m-3">
                      <vs-radio vs-value="debit" v-model="type"
                        >Bank Masuk</vs-radio
                      >
                    </li>
                    <li class="m-3">
                      <vs-radio vs-value="credit" v-model="type"
                        >Bank Keluar</vs-radio
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="w-full mt-4">
                  <label class="text-sm opacity-75">Tanggal</label>
                  <vs-input
                    class="w-full"
                    type="date"
                    v-mask="'####-##-##'"
                    v-model="date"
                    v-validate="'required'"
                    name="date"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('date')"
                    >{{ errors.first("date") }}</span
                  >
                </div>
              </div>
            </div>

            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Dibayarkan kepada</label>
                <vs-input
                  class="w-full"
                  v-model="paidTo"
                  v-validate="'required'"
                  name="paidTo"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('paidTo')"
                  >{{ errors.first("paidTo") }}</span
                >
              </div>
            </div>

            <div class="vx-row mt-2">
              <div class="vx-col w-full">
                <label class="text-sm opacity-75">Catatan</label>
                <vs-textarea
                  class="w-full"
                  v-model="notes"
                  v-validate="'required'"
                  name="notes"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('notes')"
                  >{{ errors.first("notes") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <vs-row class="mt-4">
              <vs-col class="px-1" vs-sm="12" vs-lg="7">
                <label class="text-sm opacity-75">Keterangan</label>
              </vs-col>
              <vs-col vs-sm="12" vs-lg="5">
                <vs-row>
                  <vs-col class="px-1" vs-sm="12" vs-lg="10">
                    <label class="text-sm opacity-75">Total</label>
                  </vs-col>
                  <vs-col class="px-1" vs-sm="12" vs-lg="2"> &nbsp; </vs-col>
                </vs-row>
              </vs-col>
            </vs-row>
            <template>
              <vs-row class="mb-2" v-for="(input, i) in inputs" :key="i">
                <vs-col class="px-1" vs-sm="12" vs-lg="7">
                  <vs-input
                    class="w-full"
                    v-model="input.title"
                    name="input.title"
                  />
                </vs-col>
                <vs-col vs-sm="12" vs-lg="5">
                  <vs-row>
                    <vs-col class="px-1 w-full md:w-10/12">
                      <vs-input
                        class="w-full"
                        v-model="input.amount"
                        v-money="money"
                        name="input.amount"
                      />
                    </vs-col>
                    <vs-col class="px-1" vs-sm="12" vs-lg="2">
                      <vs-button
                        class="w-full"
                        color="danger"
                        type="filled"
                        v-if="inputs.length > 1"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click="remove(i)"
                      ></vs-button>
                    </vs-col>
                  </vs-row>
                </vs-col>
              </vs-row>
            </template>
            <div class="mt-4 px-1">
              <vs-button
                class="w-full"
                color="success"
                type="filled"
                icon-pack="feather"
                icon="icon-plus"
                @click="add()"
                >Tambah</vs-button
              >
            </div>
            <div class="mt-4 px-1">Total : {{ amount.toLocaleString() }}</div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { VMoney } from 'v-money'

// Store Module
import moduleBankCashflow from '@/store/bank-cashflow/moduleBankCashflow.js'

export default {
  components: {
    vSelect,
    Datepicker
  },
  directives: { money: VMoney },
  data () {
    return {
      type: null,
      paidTo: '',
      date: '',
      debit: null,
      credit: null,
      amount: 0,
      notes: '',
      inputs: [
        {
          title: '',
          amount: '0'
        }
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      }
    }
  },
  created () {
    if (!moduleBankCashflow.isRegistered) {
      this.$store.registerModule('bankCashflow', moduleBankCashflow)
      moduleBankCashflow.isRegistered = true
    }
  },
  watch: {
    inputs: {
      handler (inputs) {
        this.amount = inputs.reduce(
          (total, input) => total + this.normalizeAmount(input.amount),
          0
        )
      },
      deep: true
    }
  },
  computed: {
    validateForm () {
      return (
        !this.errors.any() &&
        this.type !== '' &&
        this.paidTo !== '' &&
        this.date !== '' &&
        this.amount !== null
      )
    }
  },
  methods: {
    add () {
      this.inputs.push({
        title: '',
        amount: '0'
      })
    },
    remove (index) {
      if (this.inputs.length === 1) return
      this.inputs.splice(index, 1)
    },
    normalizeAmount (value) {
      if (value === null || value === undefined || value === '') return 0

      const normalized = String(value).replace(/\./g, '')
      const amount = Number.parseInt(normalized, 10)

      return Number.isFinite(amount) ? amount : 0
    },
    extractErrorMessage (error) {
      const data = error && error.response && error.response.data

      if (data && data.errors) {
        const firstError = Object.values(data.errors)[0]
        if (Array.isArray(firstError) && firstError.length) return firstError[0]
      }

      return (data && data.message) || (error && error.message) || 'Terjadi kesalahan saat menyimpan data.'
    },
    saveBankCashflow () {
      const self = this
      const bank_id = this.$route.params.id

      this.$validator.validateAll().then((result) => {
        if (result) {

          let debit = 0
          let credit = 0

          if (self.type === 'debit') {
            debit = self.amount
            credit = 0
          } else {
            debit = 0
            credit = self.amount
          }

          const formData = new FormData()
          formData.set('bank_account_id', bank_id)
          formData.set('type', self.type)
          formData.set('paid_to', self.paidTo)
          formData.set('date', self.date)
          formData.set('debit', debit)
          formData.set('credit', credit)
          formData.set('notes', self.notes)
          formData.append(
            'items',
            JSON.stringify(
              self.inputs.map((input) => ({
                title: input.title,
                amount: self.normalizeAmount(input.amount)
              }))
            )
          )

          this.$store
            .dispatch('bankCashflow/createBankCashflow', formData)
            .then(res => {
              self.$vs.notify({
                color: 'success',
                title: 'Berhasil',
                text: res.data.message
              })
              self.$router.push({ name: 'bank-account-cashflow', params: { id: this.$route.params.id}})
            })
            .catch((err) => {
              self.$vs.notify({
                color: 'danger',
                title: 'Opps..',
                text: self.extractErrorMessage(err)
              })
            })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.divider {
  background: #e0e0e0;
  height: 1px;
}
</style>
